import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';

export class LL_0001_BCU_CAN50 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0001_BCU_CAN50',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ShadowDtcList',
              isRead: 'true',
              interval: '267',
              texttableentry: 'ShadowDtcList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureSensor',
              isRead: 'true',
              interval: '268',
              texttableentry: 'FlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReturnTemperatureSensor',
              isRead: 'true',
              interval: '269',
              texttableentry: 'ReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterFlowSensor',
              isRead: 'true',
              interval: '270',
              texttableentry: 'WaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureSensor',
              isRead: 'true',
              interval: '318',
              texttableentry: 'WaterPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlueGasTemperatureSensor',
              isRead: 'true',
              interval: '331',
              texttableentry: 'FlueGasTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerSupplyValue',
              isRead: 'true',
              interval: '356',
              texttableentry: 'MainPowerSupplyValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MainPowerSupplyMinValue',
              isRead: 'true',
              interval: '357',
              texttableentry: 'MainPowerSupplyMinValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOutletSensor',
              isRead: 'true',
              interval: '360',
              texttableentry: 'DomesticHotWaterOutletSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyTemperatureLimiterOneSwitch',
              isRead: 'true',
              interval: '362',
              texttableentry: 'SafetyTemperatureLimiterOneSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Flame',
              isRead: 'true',
              interval: '364',
              texttableentry: 'Flame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanTargetSpeed',
              isRead: 'true',
              interval: '373',
              texttableentry: 'FanTargetSpeed',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanCurrentSpeed',
              isRead: 'true',
              interval: '374',
              texttableentry: 'FanCurrentSpeed',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MassFlowSensor',
              isRead: 'true',
              interval: '376',
              texttableentry: 'MassFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPump',
              isRead: 'true',
              interval: '381',
              texttableentry: 'CentralHeatingPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveTargetPosition',
              isRead: 'true',
              interval: '386',
              texttableentry: 'DiverterValveTargetPosition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPump',
              isRead: 'true',
              interval: '392',
              texttableentry: 'DomesticHotWaterPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpoint',
              isRead: 'true',
              interval: '524',
              texttableentry: 'ModulationTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValue',
              isRead: 'true',
              interval: '526',
              texttableentry: 'ModulationCurrentValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProductionTraceabilityByte',
              isRead: 'true',
              interval: '922',
              texttableentry: 'ProductionTraceabilityByte',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasType',
              isRead: 'true',
              interval: '929',
              texttableentry: 'GasType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InternalBoilerSensorTwo',
              isRead: 'true',
              interval: '959',
              texttableentry: 'InternalBoilerSensorTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustPipeType',
              isRead: 'true',
              interval: '960',
              texttableentry: 'ExhaustPipeType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecurityAlgorithmNumber',
              isRead: 'true',
              interval: '961',
              texttableentry: 'SecurityAlgorithmNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CalibrationDateTime',
              isRead: 'true',
              interval: '967',
              texttableentry: 'CalibrationDateTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AllengraSensor',
              isRead: 'true',
              interval: '1043',
              texttableentry: 'AllengraSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ShadowFreezeFrame',
              isRead: 'true',
              interval: '1082',
              texttableentry: 'ShadowFreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MassFlowSensorCorrectionFactor',
              isRead: 'true',
              interval: '1212',
              texttableentry: 'MassFlowSensorCorrectionFactor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasAirRatioCalibrationRequest',
              isRead: 'true',
              interval: '1412',
              texttableentry: 'GasAirRatioCalibrationRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatCellCondensateDetection',
              isRead: 'true',
              interval: '1586',
              texttableentry: 'HeatCellCondensateDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlueGasTemperatureSensorTwo',
              isRead: 'true',
              interval: '1767',
              texttableentry: 'FlueGasTemperatureSensorTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceProcessValues',
              isRead: 'true',
              interval: '1803',
              texttableentry: 'DebuggingInterfaceProcessValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfacePowerDemand',
              isRead: 'false',
              interval: '1804',
              texttableentry: 'DebuggingInterfacePowerDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceProgrammingMode',
              isRead: 'true',
              interval: '1805',
              texttableentry: 'DebuggingInterfaceProgrammingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceReleaseCheckTestFunctions',
              isRead: 'false',
              interval: '1806',
              texttableentry: 'DebuggingInterfaceReleaseCheckTestFunctions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
